<template>
    <footer>
      Made by
      <a href="https://twitter.com/sam___tsao" target="_blank">Sam Tsao</a>
    </footer>
</template>
<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
    name: "SiteFooter"
})
</script>